export const convertToSEOAddress = (productName: string): string => {
  // Преобразование к нижнему регистру
  productName = productName.toLowerCase();

  // Замена _ на дефисы
  productName = productName.replace(/_/g, "-");

  // Замена пробелов на дефисы
  productName = productName.replace(/ /g, "-");

  // Замена русских символов на английские эквиваленты
  const cyrillicToLatinMap: { [key: string]: string } = {
    "а": "a", "б": "b", "в": "v", "г": "g", "д": "d", "е": "e", "ё": "yo", "ж": "zh",
    "з": "z", "и": "i", "й": "y", "к": "k", "л": "l", "м": "m", "н": "n", "о": "o",
    "п": "p", "р": "r", "с": "s", "т": "t", "у": "u", "ф": "f", "х": "h", "ц": "c",
    "ч": "ch", "ш": "sh", "щ": "sch", "ъ": "%", "ы": "y", "ь": "%", "э": "e", "ю": "yu",
    "я": "ya",
  };

  const re = /[а-яё]/g;
  productName = productName.replace(re, (match) => {
    return cyrillicToLatinMap[match] || match;
  });

  // Удаление специальных символов и знаков препинания, сохраняя русские символы
  const regex = /[^\dA-Za-zА-Яа-я-]/g;
  productName = productName.replace(regex, "");

  // Удаление двойных и последних дефисов
  productName = productName.replace(/---/g, "-");
  productName = productName.replace(/--/g, "-");
  productName = productName.replace(/^-+|-+$/g, "");

  // Возвращаем результат
  return productName;
}